import { Injectable, inject } from '@angular/core';
import { McpReport, McpReportDetail } from '../../../core/models/domain.models';
import { ApiService } from '../../../core/services/api.service';

@Injectable({ providedIn: 'root' })
export class McpReportsService {
  private readonly api = inject(ApiService);

  list(product?: string | null) {
    return this.api.get<McpReport[]>('/api/mcp-reports', product ? { product } : undefined);
  }

  get(reportId: string) {
    return this.api.get<McpReportDetail>(`/api/mcp-reports/${reportId}`);
  }

  fetch(payload: { product: string; from_date?: string | null; to_date?: string | null; force_refetch?: boolean; interval?: string }) {
    return this.api.post<McpReportDetail>('/api/mcp-reports/fetch', payload);
  }

  refetch(reportId: string) {
    return this.api.post<McpReportDetail>(`/api/mcp-reports/${reportId}/refetch`, {});
  }

  downloadUrl(reportId: string) {
    return this.api.resolve(`/api/mcp-reports/${reportId}/download`);
  }
}
